import React, { ForwardedRef, useImperativeHandle, useRef } from 'react';
import Chart from '..';
import { LineChartProps, ChartRef } from '../_config/interface';
import { makeupOptions } from '../_config/utils';

const PieChartInner: React.ForwardRefRenderFunction<ChartRef, LineChartProps> = (props, ref: ForwardedRef<ChartRef>) => {
  const { className = '', style = {}, height, chartEventConfig, notMerge = false, pieOption,
    pieDataHighIndex, chartType } = props
  const chartRef = useRef<ChartRef>(null)
  const option = makeupOptions(props, 'bar')

  const getPieOption = () => {
    const optionTmp = (pieOption ? pieOption : option) || {};
    let xAxisTmp = optionTmp.xAxis || {};
    xAxisTmp = Array.isArray(xAxisTmp)
      ? xAxisTmp.map((item: any) => ({ ...item, show: false }))
      : { ...xAxisTmp, show: false };
    return {
      ...optionTmp,
      xAxis: xAxisTmp,
    };
  };

  // 获取实例
  const instance = () => {
    return chartRef?.current?.instance();
  }

  // 对父组件暴露的方法
  useImperativeHandle(ref, () => ({
    instance
  }));

  const chartStyle = {
    ...(height ? { height: `${height}px` } : {}),
    width: '100%',
    ...style
  }

  return (
    <div className={`chart-box ${className}`} style={chartStyle}>
      <Chart ref={chartRef} option={getPieOption()} chartEventConfig={chartEventConfig} notMerge={notMerge}
        pieDataHighIndex={pieDataHighIndex}
        chartType={chartType} />
    </div>
  );
}

const PieChart = React.forwardRef(PieChartInner);

export default PieChart;
